var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "row--small font-size-14",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "3",
      "md": "2"
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]), _c('v-col', {
    attrs: {
      "cols": "9",
      "md": "10"
    }
  }, [_vm._t("default")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }